import { Injectable } from '@angular/core';
import {AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource} from "@irian-ro/abstract-resource";
import { HttpClient } from "@angular/common/http";
import { EnvironmentService } from '@irian-ro/util-environment';
import {WorkflowConfigDtoModel, WorkflowListVoModel} from "@well/iriro-frontend-libs/workflows/domain";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})

export class WorkflowResourceService extends AbstractResourceService<WorkflowListVoModel, WorkflowConfigDtoModel, JsonApiListResourceMetadataBase, any>{

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('workflowsUrl'),
      WorkflowListVoModel,
      WorkflowConfigDtoModel,
      JsonApiListResourceMetadataBase,
      <any>null
    )
  }

  invalidateWorkflowDefinitionsAndConfigs(invalidWorkflowsUuid: string[], systemName: string): Observable<JsonApiResource<WorkflowListVoModel[], null>> {
    return this.httpClient.put(`${this.url}/invalidate/list?workflowDefinitionUuids=${invalidWorkflowsUuid.join(',')}&systemName=${systemName}`,{headers: this.headers}).pipe(this.mapToListOfObjects());
  }

}
